<template>
    <div class="tw:flex tw:flex-col tw:items-center tw:justify-center tw:py-6">
        <div
            class="tw:inline-flex tw:items-center tw:justify-center tw:w-12 tw:h-12 tw:rounded-full tw:bg-gray-100 tw:mb-3">
            <i :class="icon"></i>
        </div>
        <h3 class="tw:text-sm tw:font-medium tw:text-gray-900">{{ title }}</h3>
        <p class="tw:mt-1 tw:text-sm tw:text-gray-500">
            {{ description }}
        </p>
    </div>
</template>
<script>
export default {
    name: "BaseEmpty",
    props: {
        title: {
            type: String,
            default: "No hay datos"
        },
        description: {
            type: String,
            default: "No se encontraron registros."
        },
        icon: {
            type: String,
            default: "fa fa-box"
        }
    }
}
</script>